import axiosInstance from "./AxiosConfig";

class AccountManagerInformationService {
  async CreateAccountManagerInformation(data) {
    
    const payload = {
      branchId: data.branchId,
      acManagerId: data.accountManagerId,
      active: data.active,
    };
    try {
      const response = await axiosInstance.post(
        "/accountManagerInformation/create",
        payload
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAllAccountManagerInformation() {
    try {
      const response = await axiosInstance.get(
        "/accountManagerInformation/get"
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateAccountManagerInformation(id, data) {
    
    const payload = {
      branchId: data.branchId,
      acManagerId: data.accountManagerId,
      active: data.active,
    };
    try {
      const response = await axiosInstance.put(
        `/accountManagerInformation/update/${id}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteAccountManagerInformation(id) {
    try {
      const response = await axiosInstance.delete(
        `/accountManagerInformation/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAccountManagerInformationById(id) {
    try {
      const response = await axiosInstance.get(
        `/accountManagerInformation/getbyid/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new AccountManagerInformationService();
